/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sis-wizard-progress',
    templateUrl: './wizard-progress.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class WizardProgressComponent {
    /**
     * Translation keys of the wizard steps to show.
     */
    @Input({ required: true }) stepKeys: readonly string[];

    /**
     * Zero-based index of the selected step in {@link stepKeys}.
     */
    @Input({ required: true }) currentStep: number;

    /**
     * An optional aria-label, which may be used to provide more information about the content of the wizard progress
     */
    @Input() ariaLabel: string;
}
